"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpClient_1 = require("../core/HttpClient");
var ZonepartsModel = /** @class */ (function () {
    function ZonepartsModel() {
        this.$http = HttpClient_1.HttpClient;
        this.extract = this.extract.bind(this);
    }
    ZonepartsModel.prototype.extract = function (result) {
        return result.data;
    };
    /**
     * Get all zoneparts for a school
     * GET /api/v1/schools/{school_id}/zoneparts
     */
    ZonepartsModel.prototype.getZoneparts = function (schoolId) {
        return this.$http
            .get("schools/".concat(schoolId, "/zoneparts"))
            .then(this.extract)
            .then(function (response) { return response.zoneparts; });
    };
    /**
     * Get a single zonepart
     * GET /api/v1/schools/{school_id}/zoneparts/{id}
     */
    ZonepartsModel.prototype.getZonepart = function (schoolId, zonepartId) {
        return this.$http
            .get("schools/".concat(schoolId, "/zoneparts/").concat(zonepartId))
            .then(this.extract)
            .then(function (response) { return response.zonepart; });
    };
    /**
     * Create a new zonepart
     * POST /api/v1/schools/{school_id}/zoneparts
     */
    ZonepartsModel.prototype.createZonepart = function (schoolId, data) {
        return this.$http
            .post("schools/".concat(schoolId, "/zoneparts"), data)
            .then(this.extract)
            .then(function (response) { return response.zonepart; });
    };
    /**
     * Update a zonepart
     * PUT /api/v1/schools/{school_id}/zoneparts/{id}
     */
    ZonepartsModel.prototype.updateZonepart = function (schoolId, zonepartId, data) {
        return this.$http
            .put("schools/".concat(schoolId, "/zoneparts/").concat(zonepartId), data)
            .then(this.extract)
            .then(function (response) { return response.zonepart; });
    };
    /**
     * Delete a zonepart
     * DELETE /api/v1/schools/{school_id}/zoneparts/{id}
     */
    ZonepartsModel.prototype.deleteZonepart = function (schoolId, zonepartId) {
        return this.$http
            .delete("schools/".concat(schoolId, "/zoneparts/").concat(zonepartId))
            .then(this.extract);
    };
    return ZonepartsModel;
}());
exports.default = ZonepartsModel;
